import React, {
  createContext, useState, useContext, useMemo,
} from 'react';
import PropTypes from 'prop-types';

const ModalContext = createContext({
  currentModal: null,
  // eslint-disable-next-line no-unused-vars
  openModal: (modal) => {},
  closeModal: () => {},
});

export const useModal = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [openedModal, setOpenedModal] = useState(null);
  const closeModal = () => setOpenedModal(null);

  const modalMemo = useMemo(() => ({
    currentModal: openedModal,
    openModal: setOpenedModal,
    closeModal,
  }), [openedModal, setOpenedModal, closeModal]);

  return (
    <ModalContext.Provider value={modalMemo}>
      {children}
    </ModalContext.Provider>
  );
}

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
